import PollGauge from '@/containers/DevToolsNew/CommunicationBoard/PollResults/PollGauge/PollGauge'
import PollScoreBars from '@/containers/DevToolsNew/CommunicationBoard/PollResults/PollScoreBars/PollScoreBars'
import PollVoterList from '@/containers/DevToolsNew/CommunicationBoard/PollResults/PollVoterList/PollVoterList'
import type { PollResult } from '@/containers/DevToolsNew/CommunicationBoard/PollResults/types'
import usePollResultCard from './usePollResultCard'
import {
  ResultBody,
  ResultCard,
  ResultHeader,
  ResultSummary,
  ResultTitle,
  StatusChip,
  VotersToggle,
} from './styled-components'

interface PollResultCardProps {
  poll: PollResult
  expanded: boolean
}

const PollResultCard = ({ poll, expanded }: PollResultCardProps) => {
  const {
    title,
    open,
    statusLabel,
    summary,
    average,
    averageLabel,
    bars,
    voters,
    votersHidden,
    toggleHidden,
    toggleLabel,
    onToggleVoters,
  } = usePollResultCard(poll, expanded)

  return (
    <ResultCard>
      <ResultHeader>
        <div>
          <ResultTitle>{title}</ResultTitle>
          <ResultSummary>{summary}</ResultSummary>
        </div>
        <StatusChip $open={open}>{statusLabel}</StatusChip>
      </ResultHeader>
      <ResultBody>
        <PollGauge average={average} label={averageLabel} />
        <PollScoreBars bars={bars} />
      </ResultBody>
      <VotersToggle type='button' hidden={toggleHidden} aria-expanded={expanded} onClick={onToggleVoters}>
        {toggleLabel}
      </VotersToggle>
      <PollVoterList voters={voters} hidden={votersHidden} />
    </ResultCard>
  )
}

export default PollResultCard
